angular.module('powerOfAttorney')
    .controller('PowerOfAttorneyEditController', function ($scope, $state, $rootScope, toastr, PowerOfAttorney, item, PowerOfAttorneyService, PowerOfAttorneyConst) {
        this.PowerOfAttorneyService = PowerOfAttorneyService

        this.$onInit = () => {
            this.item = item
        }

        this.save = () => {
            let promise
            if (this.item.id != null) {
                promise = PowerOfAttorney.update(this.item).$promise
            } else {
                promise = PowerOfAttorney.save(this.item).$promise
            }
            return promise.then(() => {
                $rootScope.$broadcast(PowerOfAttorneyConst.eventUpdate)
                toastr.success("Zapisano")
                if(this.item.id != null)
                    $state.go('powerOfAttorneyShowFull', {id: this.item.id})
                else
                    $state.go('powerOfAttorneyList')
            })
        }

        $scope.$on("file.saved", () => $state.reload())
    })
